<script setup>
import { computed } from 'vue';
import { cn } from 'dashboard/components-next/ui-shadcn/utils';

const props = defineProps({
  class: { type: [String, Array, Object], default: '' },
});

const classes = computed(() => cn('p-4 pt-0 flex-1', props.class));
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
